import { IClient, ClientSchema } from '@/validations/client';
import * as Sentry from '@sentry/capacitor';
import { getFirestore, collection, CollectionReference, getDoc, doc } from 'firebase/firestore';

import { toast } from '@/components/Toaster/Toast';

import Logger from './CapcitorLog';
import { safePromise } from './safePromise';

export async function getFirebaseClientByClientId(clientId: string): Promise<IClient | undefined> {
  const firestore = getFirestore();

  const clientsReference = collection(firestore, 'clients') as CollectionReference<IClient>;

  // Get the config from the database
  const [data, error] = await safePromise(getDoc(doc(clientsReference, clientId)));

  if (error) {
    toast({
      variant: 'error',
      title: 'Unable to fetch client',
      description: 'Please try again later',
    });

    return undefined;
  }

  // Check if the config exists
  if (!data || !data.exists()) {
    toast({
      variant: 'error',
      title: 'Could not find client',
      description: 'Please try again later',
    });

    return undefined;
  }

  const client = ClientSchema.safeParse(data.data());

  if (!client.success) {
    Logger.error('Invalid client', client.error);
    Sentry.captureException(client.error);

    toast({
      variant: 'error',
      title: 'Invalid client',
      description: 'Please try again later',
    });

    return undefined;
  }

  return client.data;
}

export type { IClient, ClientSchema };
